@if (visible) {
  <div class="popup-backdrop">
    <!-- <button class="close-button" (click)="close()">X</button> -->
  
    <div class="popup-box">
      <ng-container>
        <app-logo></app-logo>
        <h2>Richiedi una chiamata dal nostro nutrizionista</h2>
        <div class="container">
          <div class="container__left">
            <p>Ti assistiamo per la dieta del tuo cane: <br /></p>
            <!--class="accented"-->
            <p>
              <strong
                >consulenza gratuita <br />
                + 30% di sconto</strong
              ><br />
              sulla prima consegna
            </p>
          </div>
          <div class="container__right">
            <img src="/home-page/images/ciotolapopup.png" alt="" />
          </div>
        </div>
  
        <button class="main-btn" (click)="handleWhatsappClick()">
          {{ ctaLabel }}
        </button>
        <button class="main-btn nutrizionista-btn" (click)="close()">
          Più tardi
        </button>
      </ng-container>
    </div>
  </div>
}
